// extracted by mini-css-extract-plugin
export default {"wrapper":"WipWrapper_wrapper__Fqkm4","text":"WipWrapper_text__2ALQU"};